module.exports = __webpack_public_path__ + "img/camera-off.50012534.svg";